export default "__VITE_ASSET__caeab20a__"